// extracted by mini-css-extract-plugin
export default {"no-tasks-icon":"TaskTabColumn_no-tasks-icon__myMZM"};